import gql from "graphql-tag";
import { Files, Files_files } from "@/models/queries/types/Files";

export const FILE_OVERVIEW_QUERY = gql`
  query Files {
    files {
      id
      fileName
      fileCategory {
        name
      }
      uploader {
        name
      }
      url
      company
    }
  }
`;

export type File = Files_files;
export type FileOverviewResult = Files;
